import Loader from "components/Loader/Loader";
import { useAppDispatch } from "hooks/hooks";
import { debounce } from "lodash";
import { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import { getBuildingsList, getSalesUnitStatuses, selectState, setBuilding } from "../main.slice";
import { hrsService } from "../../../services/hrs.services";
import TableRow from "./TableRow";
import { IBuildingWithSalesUnits } from "Dashboard/scenes/HighRiseSales/domain/IBuildingWithSalesUnits";
import { IBuildingUpdate } from "Dashboard/scenes/HighRiseSales/domain/IBuildingUpdate";
import { useSUTypeOptions } from "Dashboard/scenes/HighRiseSales/hooks/SalesUnitTypeOptions";
import { useEmployeeOptions } from "Dashboard/scenes/HumanResources/hooks/EmployeeOptions";
import DeleteBuildingModal from "./DeleteItemModal";
import { IBuilding } from "Dashboard/scenes/HighRiseSales/domain/IBuilding";

const TopSection = () => {
  const { buildings, loading } = useSelector(selectState);
  const dispatch = useAppDispatch();
  const employeeOptions = useEmployeeOptions();
  const salesUnitTypeOptions = useSUTypeOptions();

  useEffect(() => {
    dispatch(getBuildingsList({}));
    dispatch(getSalesUnitStatuses());
  }, []);

  const delayedUpdateBuilding = useCallback(
    debounce(async (data: IBuildingUpdate, originalBuilding: IBuilding) => {
      try {
        await hrsService.updateBuilding(data);
      } catch (err) {
        console.error("Ažuriranje zgrade neuspešno, vraćam stare promene.", err);
        const revertData: IBuildingUpdate = { ...originalBuilding };
        dispatch(setBuilding(revertData));
      }
    }, 1000), [dispatch]
  );

  const updateBuilding = (data: IBuildingUpdate) => {
    const originalBuildingData = buildings.find(
      (b) => b.building.buildingId === data.buildingId
    );

    if (!originalBuildingData) {
      console.error("Zgrada za ažuriranje nije pronađena.");
      return;
    }
    dispatch(setBuilding(data));
    delayedUpdateBuilding(data, originalBuildingData.building);
  };

  return (
    <div className="g-grid g-content">
      {loading && <Loader />}
      {buildings.map((building: IBuildingWithSalesUnits, index: number) => (
        <TableRow
          building={building}
          key={`${building.building.buildingId}`}
          index={index}
          updateBuilding={updateBuilding}
          employees={employeeOptions}
          salesUnitTypes={salesUnitTypeOptions}
        />
      ))}
      <DeleteBuildingModal />
    </div>
  );
};

export default TopSection;

